// extracted by mini-css-extract-plugin
module.exports = {"title":"PoCustomerDetails_title__187w3","input":"PoCustomerDetails_input__2M4NC"};